import createIcon from '../../createIcon';

/**
 * @component @name SquareFoot
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuNjYgMTcuNjZMMTYuNiAxOC43MkwxNS44OSAxOC4wMUwxNi45NSAxNi45NUwxNS4wMSAxNS4wMUwxMy45NSAxNi4wN0wxMy4yNCAxNS4zNkwxNC4zIDE0LjNMMTIuMzYgMTIuMzZMMTEuMyAxMy40MkwxMC41OSAxMi43MUwxMS42NSAxMS42NUw5LjcgOS43TDguNjQgMTAuNzZMNy45MyAxMC4wNUw4Ljk5IDguOTlMNy4wNSA3LjA1TDUuOTkgOC4xMUw1LjI4IDcuNEw2LjM0IDYuMzRMNCA0VjE4QzQgMTkuMSA0LjkgMjAgNiAyMEgyMEwxNy42NiAxNy42NlpNNyAxN1YxMS4yNEwxMi43NiAxN0g3WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SquareFoot = createIcon('SquareFoot', [
  [
    'path',
    {
      d: 'M17.66 17.66L16.6 18.72L15.89 18.01L16.95 16.95L15.01 15.01L13.95 16.07L13.24 15.36L14.3 14.3L12.36 12.36L11.3 13.42L10.59 12.71L11.65 11.65L9.7 9.7L8.64 10.76L7.93 10.05L8.99 8.99L7.05 7.05L5.99 8.11L5.28 7.4L6.34 6.34L4 4V18C4 19.1 4.9 20 6 20H20L17.66 17.66ZM7 17V11.24L12.76 17H7Z',
      key: '1ey4l1',
    },
  ],
]);

export default SquareFoot;
